import { DoubleArrow } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import { IntSummaryStatistics } from '../modules/generated/api';

import IconValue from './IconValue';
import PackageDetailMinMaxRows from './PackageDetailMinMaxRows';
import UnitValue from './UnitValue';

type PackageDetailTileMileageProps = {
  mileage?: IntSummaryStatistics;
};

const PackageDetailTileMileage = ({ mileage }: PackageDetailTileMileageProps) => {
  const { t } = useTranslation();

  return (
    <IconValue icon={DoubleArrow} label={t('car.mileage')} padding>
      <PackageDetailMinMaxRows
        min={<UnitValue value={mileage?.min} unit="km" />}
        avg={<UnitValue value={mileage?.average != null ? Math.round(mileage.average) : undefined} unit="km" />}
        max={<UnitValue value={mileage?.max} unit="km" />}
      />
    </IconValue>
  );
};

export default PackageDetailTileMileage;
